<template>
  <div class="view-bridge-pair">
    <p class="view-bridge">{{ cleanText }}</p>
    <transition name="translation-reveal">
      <p v-if="translatedText" class="view-bridge-translation" :lang="translationLang">{{ translatedText }}</p>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ViewBridge',
  props: {
    bridge: {
      type: Object,
      required: true,
    },
    translatedText: { type: String, default: '' },
    translationLang: { type: String, default: 'en-x-mtfrom-und' },
  },
  computed: {
    cleanText() {
      return String(this.bridge?.text || '')
        .replace(/\s*\[[a-z0-9_-]+:[^\]]+\]/gi, '')
        .replace(/\s*\[(?:\d+(?:\s*,\s*\d+)*)\]/g, '')
        .replace(/\s+([.,!?])/g, '$1')
        .trim();
    },
  },
};
</script>

<style scoped>
.view-bridge {
  max-width: 46em;
  margin: 1.6rem 0;
  color: #4f4f4f;
  font-family: "PT Serif", Georgia, serif;
  font-size: 16px;
  line-height: 1.8;
  text-wrap: pretty;
}

.view-bridge-translation {
  max-width: 46em;
  margin: -0.9rem 0 1.6rem;
  padding-left: 0.9rem;
  border-left: 1px solid color-mix(in srgb, var(--view-accent) 46%, transparent);
  color: color-mix(in srgb, var(--view-muted) 88%, transparent);
  font-family: "Quattrocento Sans", sans-serif;
  font-size: 0.93rem;
  line-height: 1.65;
  text-wrap: pretty;
}
.translation-reveal-enter-active,
.translation-reveal-leave-active { transition: opacity 180ms ease, transform 200ms cubic-bezier(0.22, 1, 0.36, 1); }
.translation-reveal-enter-from,
.translation-reveal-leave-to { opacity: 0; transform: translateY(-0.25rem); }

body.dark-mode .view-bridge {
  color: #c2c2c2;
}
body.dark-mode .view-bridge-translation {
  color: var(--site-text-tertiary);
}
@media (prefers-reduced-motion: reduce) {
  .translation-reveal-enter-active,
  .translation-reveal-leave-active { transition: opacity 0.01ms linear; }
  .translation-reveal-enter-from,
  .translation-reveal-leave-to { transform: none; }
}
</style>
